import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../constants/api';
import ContactLogo from '../components/shared/ContactLogo';

const PaymentPendingPage = () => {
  const navigate = useNavigate();
  // MercadoPago's own redirect appends "external_reference" (and
  // "preference_id"), never "ref" — this page was never actually
  // reachable from a real MercadoPago redirect before (see server.py's
  // back_urls), so this mismatch went unnoticed.
  const searchParams = new URLSearchParams(window.location.search);
  const externalRef = searchParams.get('ref') ||
                       searchParams.get('external_reference') ||
                       searchParams.get('preference_id');

  return (
    <div className="min-h-screen bg-gradient-to-b from-yellow-50 to-white flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Pago Pendiente
        </h1>
        
        <p className="text-gray-600 mb-6">
          Tu pago está siendo procesado. Te notificaremos por correo cuando se confirme la transacción.
        </p>

        {externalRef && (
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-600 mb-2">
              Referencia: <span className="font-mono font-medium">{externalRef}</span>
            </p>
            <p className="text-xs text-gray-500">
              Guarda este número para consultar el estado de tu pedido.
            </p>
          </div>
        )}

        <div className="space-y-3">
          <button
            onClick={() => navigate('/')}
            className="w-full bg-[#004AAD] hover:bg-[#5170FF] text-white py-3 rounded-lg font-semibold transition-colors"
          >
            Volver al Inicio
          </button>
          <p className="text-sm text-gray-500">
            Recibirás un correo de confirmación una vez que se procese el pago.
          </p>
        </div>
      </div>
    </div>
  );
};

// Activation Component

export default PaymentPendingPage;
